import {useLoading} from "../../context/Loading";
import Footer from "../../components/Footer";
import LoadingModal from "../../components/LoadingModal";
import {Box} from "@mui/material";
import Main from "./Main";
import {Outlet} from "react-router-dom";

export default function Dashboard() {
    const {loading} = useLoading();


    return (
        <>
            {loading && <LoadingModal/>}
            <Box
                sx={{
                    height: "100vh",
                    display: {lg: "flex"},
                    minHeight: {lg: 1}
                }}>
                <Main>
                    <Outlet/>
                </Main>
            </Box>
        </>
    )
}